import * as z from "zod/v4";

// Zod's JIT parser compiles via the Function constructor, which CSP treats as eval — every page
// load reports a script-src violation (PCI 11.6.1 noise). jitless uses the interpreted parser.
// Zod snapshots this flag when a schema is CONSTRUCTED, so it must be set before any module-scope
// z.object() runs; Next guarantees this file executes before all other client code.
z.config({ jitless: true });
